import React from "react"
import { Typography, Box } from "@material-ui/core"
import { makeStyles } from "@material-ui/styles"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

const useStyles = makeStyles((theme) => ({
  master: {
    minHeight: 80,
    borderTop: ({ topBorder }) => (topBorder ? "1px solid #efefef" : "none"),
    borderBottom: ({ bottomBorder }) => (bottomBorder ? "1px solid #efefef" : "none"),
    cursor: ({ disabled }) => (disabled ? "inherit" : "pointer"),
    "&:hover": {
      backgroundColor: ({ disabled }) => (disabled ? "inherit" : theme.palette.lists.itemHover),
    },
    color: ({ disabled }) => theme.palette.text[disabled ? "disabled" : "main"],
  },
  icon: {
    margin: `0 ${theme.spacing(3)}px 0 13px`,
    marginTop: 27,
  },
  title: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: "20px",
  },
  value: {
    fontSize: 16,
    lineHeight: "20px",
    whiteSpace: "pre-wrap",
  },
  noValue: {
    color: ({ disabled }) => theme.palette.text[disabled ? "disabled" : "light"],
  },
  arrow: {
    marginTop: 27,
    minWidth: 0,
    marginRight: theme.spacing(1),
  },
}))

const AssignerDisplay = ({
  icon,
  title,
  placeholder,
  value,
  onClick,
  className,
  topBorder = true,
  bottomBorder = true,
  disabled = false,
  cy,
}) => {
  const classes = useStyles({ topBorder, bottomBorder, disabled })

  const handleClick = (event) => {
    if (!disabled && onClick) onClick(event)
  }

  return (
    <Box
      display="flex"
      flexDirection="row"
      className={`${classes.master} ${className}`}
      onClick={handleClick}
      data-cy={cy}
    >
      <Box className={classes.icon}>{icon}</Box>
      <Box display="flex" flexGrow={1} flexDirection="column" mt={1} mb={1} alignSelf="center">
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.value}>
          {value || <span className={classes.noValue}>{placeholder || "Nothing selected"}</span>}
        </Typography>
      </Box>
      <Box className={classes.arrow}>
        <Box ml="auto">
          <ChevronRightIcon />
        </Box>
      </Box>
    </Box>
  )
}

export { AssignerDisplay }
